import React from "react";
import Reseller from "../../Models/Reseller";
import { Button, DialogContent, Grid, Paper, Switch, Typography } from "@mui/material";
import { useDialog } from "../../utils/DialogProvider";
import GridRowDescriptionWithTextField from "../components/EditFields/GridRowDescriptionWithTextField";
import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper";
// @ts-ignore
import AsynchronousAutocomplete from "../../../components/Autocomplete/AsynchronousAutocomplete";

type EditResellerProps = {
  reseller: Reseller;
  onSave: (reseller: Reseller) => Promise<any>;
};

function EditReseller(props: EditResellerProps) {
  const [reseller, setReseller] = React.useState<Reseller>(props.reseller);

  const [, closeDialog] = useDialog();
  return (
    <DialogContent>
      <Paper>
        <Typography variant={"h6"}>Reseller</Typography>

        <Grid container spacing={1} style={{ maxWidth: 480 }}>
          <Grid container item xs={12}>
            <GridRowDescriptionWithTextField
              description={"Name"}
              onChange={(e) => {
                reseller.description = e.target.value;
                setReseller(Object.assign(Object.create(reseller), reseller));
              }}
              value={reseller.description}
            />
          </Grid>

          <Grid container item xs={12}>
            <Grid item xs={6}>
              <TranslationWrapper tDefault={"transactionKickback"} tKey={"transactionKickback"} />
            </Grid>
            <Grid item xs={6}>
              <Switch
                checked={reseller.transactionKickback}
                onChange={(e) => {
                  reseller.transactionKickback = e.target.checked;
                  setReseller(Object.assign(Object.create(reseller), reseller));
                }}
              />
            </Grid>
          </Grid>

          <Grid container item xs={12}>
            <Grid item xs={6}>
              <TranslationWrapper tKey={"Debtor"} />
            </Grid>
            <Grid item xs={6}>
              <AsynchronousAutocomplete
                async={{
                  url: "core/subsDebtor/search?fields=id as value, company_name as label&per_page=30",
                  searchField: "company_name",
                }}
                disableClearable={true}
                onChange={(e: any, option: any) => {
                  reseller.subs_debtor_id = option.value;
                  setReseller(Object.assign(Object.create(reseller), reseller));
                }}
              />
            </Grid>
          </Grid>

          {props.onSave ? (
            <Grid container item justify={"center"} xs={12}>
              <Button
                color={"primary"}
                onClick={() => {
                  if (props.onSave) {
                    props.onSave(reseller).then(() => {
                      closeDialog();
                    });
                  }
                }}
                variant={"contained"}
              >
                Save
              </Button>
            </Grid>
          ) : null}
        </Grid>
      </Paper>
    </DialogContent>
  );
}

export default EditReseller;
